'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Educations;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RequiredEducation = require('shared/components/RequiredEducation');

var _RequiredEducation2 = _interopRequireDefault(_RequiredEducation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'educations';

function Educations(_ref) {
  var levels = _ref.levels,
      user = _ref.user,
      required = _ref.required,
      preferred = _ref.preferred;

  return _react2.default.createElement(
    'div',
    {
      className: CLASS_NAME
    },
    _react2.default.createElement(
      'div',
      { className: 'education-content' },
      _react2.default.createElement(
        'h3',
        null,
        'Required Education'
      ),
      _react2.default.createElement(_RequiredEducation2.default, {
        educationLevels: levels,
        job: {
          education: {
            required: required
          }
        },
        user: user
      }),
      _react2.default.createElement('hr', null),
      _react2.default.createElement(
        'h3',
        null,
        'Preferred Education'
      ),
      _react2.default.createElement(
        'p',
        null,
        preferred
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/Content/Education/Education.jsx
// module id = 1189
// module chunks = 0